import styled from 'styled-components';

export default styled.section`
  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    max-width: ${props => props.theme.maxWidths.usefulLinks};
  }

  header {
    margin-bottom: 1.25rem;

    h2 {
      margin: 0;
    }
  }

  .links {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      padding: 0.6875rem 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      border-bottom: solid 1px ${props => props.theme.colors.grey5};

      &:first-child {
        padding-top: 0;
      }

      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
      }

      a {
        sup {
          border: none;
        }
      }

      > svg {
        color: ${props => props.theme.colors.vmfBlue};
        margin-right: 0.625rem;
      }
    }
  }
`;
